import {
  isNil,
  isNonEmptyString,
  isNonEmptyArray,
  isNonEmptyObject,
  isNumber,
  isNull,
  isUndefined,
  isBoolean
} from './checks'

const removeEmptyKeysAndValues = (obj: unknown): unknown => {
  if (!isNonEmptyObject(obj)) {
    return obj
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (isUndefined(value) || isNull(value) || isNil(value)) {
      return acc
    }

    if (isNumber(value) || isBoolean(value) || isNonEmptyString(value)) {
      return { ...acc, [key]: value }
    }

    if (isNonEmptyArray(value)) {
      const filteredArray = value.filter(
        (item) => !isUndefined(item) && !isNull(item) && !isNil(item)
      )
      return filteredArray.length > 0 ? { ...acc, [key]: filteredArray } : acc
    }

    if (isNonEmptyObject(value)) {
      const cleanedValue = removeEmptyKeysAndValues(value)
      return Object.keys(cleanedValue as object).length > 0
        ? { ...acc, [key]: cleanedValue }
        : acc
    }

    return acc
  }, {})
}

export default removeEmptyKeysAndValues
